
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { WorkflowItemProps } from ".";
import { loading, find } from "store/workflow";

interface ApiWorkflowFindByIdInputProps {
    id: number;
}

type ApiWorkflowFindOutputProps = OutputBaseProps<{ item: WorkflowItemProps; }, ApiWorkflowFindByIdInputProps>

export const apiWorkflowFindById = async (data: ApiWorkflowFindByIdInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiWorkflowFindOutputProps>(`/api/workflow/${data.id}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};


interface ApiWorkflowFindByCodeInputProps {
    code: string;
}

export const apiWorkflowFindByCode = async (data: ApiWorkflowFindByCodeInputProps) => {
    store.dispatch(loading());
    const res = (await axios.get<ApiWorkflowFindOutputProps>(`/api/workflow/code/${data.code}`))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(find({ data: res.data.item }));
    }
    return res;
};